import { render, staticRenderFns } from "./IndicatorsGreen.vue?vue&type=template&id=816c9e2e&scoped=true&"
import script from "./IndicatorsGreen.vue?vue&type=script&lang=js&"
export * from "./IndicatorsGreen.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsGreen.vue?vue&type=style&index=0&id=816c9e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816c9e2e",
  null
  
)

export default component.exports